import Swiper from "swiper";

var swiper = new Swiper(".swiper-container", {
    breakpoints: {
        640: {
            slidesPerView: 1,
            spaceBetween: 0,
            slidesPerGroup: 1
        }
    },
    slidesPerView: 3,
    spaceBetween: 45,
    slidesPerGroup: 3,
    loop: true,
    loopFillGroupWithBlank: true,
    speed: 500,
    navigation: {
        nextEl: ".galleryProdotti__arrow_next",
        prevEl: ".galleryProdotti__arrow_prev"
    }
});
